<template>
  <Header title="blog" />

  <!-- Pass in feed as prop (posts) -->
  <BlogContent />
</template>

<script>
import BlogContent from "@/components/layouts/BlogContent.vue";
import BlogCards from "@/components/layouts/BlogCards.vue";
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";

export default {
  components: {
    Container,
    Header,
    BlogCards,
    BlogContent,
  },
};
</script>
